//? 이메일에서 연장 요청을 클릭했을 때 보여지는 페이지

import { cancelMeetingReservation } from "apis/meetings/meeting-reservation";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { LoadingModal } from "uis/modal";
import { MeetingRedirectServices } from "./services";
import { TEmailNoShowRepeatReservation } from "./types";
import RepeatCancelModal from "./modals/repeat-cancel-modal";
import NotRepeatCancelModal from "./modals/not-repeat-cancel-modal";

const CancelReservation = () => {
  const meetingRedirectService = new MeetingRedirectServices();
  const [detailInfo, setDetailInfo] = useState<TEmailNoShowRepeatReservation | null>(null);
  const [openNotRecurringCancelModal, setOpenNotRecurringCancelModal] = useState(false);

  const { page, id, messageId, memberPublicId } = useParams<{
    page: string;
    id: string;
    messageId: string;
    memberPublicId: string;
  }>();
  const isUsageConfirmAlarm = page === "usage-confirm-alarm";
  const isNMinutes = page === "n-minutes";
  const isNoshow = page === "noshow";
  const isRecurring = page === "repeat";

  const messageLocation = isUsageConfirmAlarm ? "USAGE_CONFIRM_ALARM" : isNMinutes ? "REMINDER" : "NOSHOW_WARNING";

  useEffect(() => {
    if (isRecurring && id) {
      //* 노쇼 반복 예약 상세 정보 조회 & 삭제 확인 모달 띄우기
      meetingRedirectService.getNoshowDetailInfo(id).then((res) => {
        if (res) {
          setDetailInfo(res);
        }
      });
    } else if (id && messageId && memberPublicId) {
      //* 단일 예약 취소 모달 띄우기
      setOpenNotRecurringCancelModal(true);
    }
  }, []);

  return (
    <>
      <LoadingModal modalIsOpen={true} />
      <NotRepeatCancelModal
        closeModal={() => {}}
        openModal={openNotRecurringCancelModal}
        onHandleCancel={async () => {
          if (id && messageId && memberPublicId) {
            const res = await cancelMeetingReservation(id, messageId, memberPublicId, messageLocation);
            if (res.success) {
              alert("회의실 예약이 취소되었습니다.");
              window.close();
            } else {
              if (res.status === 409) {
                alert("예약 종료 시간이 경과하여, 바로 취소가 불가합니다.");
                window.close();
              } else {
                alert("회의실 예약을 취소할 수 없습니다. 다시 시도해주세요.");
                window.close();
              }
            }
          }
        }}
      />

      <RepeatCancelModal
        reservationInfo={detailInfo}
        onHandleCancel={async () => {
          if (id && memberPublicId) await meetingRedirectService.cancelNoshow(id, memberPublicId);
        }}
        openModal={detailInfo !== null}
        closeModal={() => {}}
        type={"cancel"}
      />
    </>
  );
};

export default CancelReservation;
